'use strict';

module.exports = require('./slider');


//////////////////
// WEBPACK FOOTER
// /Users/niko/Work/sketch/antd-pro/ant-design-pro-site/scaffold/node_modules/_react-slick@0.16.0@react-slick/lib/index.js
// module id = 470
// module chunks = 0